import { render, staticRenderFns } from "./PatientHeader.vue?vue&type=template&id=1a5d1e8d&scoped=true"
import script from "./PatientHeader.vue?vue&type=script&lang=js"
export * from "./PatientHeader.vue?vue&type=script&lang=js"
import style0 from "./PatientHeader.vue?vue&type=style&index=0&id=1a5d1e8d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5d1e8d",
  null
  
)

export default component.exports